//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import breakpointMixin from '~/mixins/breakpointMixin'

export default {
  mixins: [breakpointMixin],
  props: {
    products: { type: Array, required: true }
  },
  data () {
    return {
      activePostId: null
    }
  },
  computed: {
    limit () {
      return this.isMdBreakpointOrAbove ? 9 : 8
    },
    posts () { return this.$store.getters['insta/postsForProducts'](this.products).slice(0, this.limit) },
    activePost () {
      if (!this.activePostId) return {}
      return this.posts.find(post => post.id === this.activePostId) || {}
    },
    activePostIdx () {
      return this.posts.findIndex(post => post.id === this.activePostId)
    },
    showPopupPrevious () {
      return this.activePostIdx > 0
    },
    showPopupNext () {
      return this.activePostIdx < this.posts.length
    }
  },
  methods: {
    goToNextActivePost () {
      this.activePostId = this.posts[this.activePostIdx + 1].id
    },
    goToPreviousActivePost () {
      this.activePostId = this.posts[this.activePostIdx - 1].id
    }
  }
}
